import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import fetchCurrentSiteUser from 'widget/redux/server/actions/current-site-user/get';

import DataLoader from 'shared/data-components/_data-loader';


@connect(null, {
  fetchCurrentSiteUser,
})
export default class CurrentSiteUser extends DataLoader {

  static displayName = 'CurrentSiteUser';

  static propTypes = {
    fetchCurrentSiteUser: PropTypes.func,
  };

  state = {
    isFetching: false,
  };

  @autobind
  setFetchingState() {
    this.setState({
      isFetching: false,
    });
  }

  @autobind
  unsetFetchingState() {
    this.setState({
      isFetching: false,
    });
  }

  loadData() {
    this.setFetchingState();
    const loadingPromise = this.props.fetchCurrentSiteUser();
    loadingPromise.then(this.unsetFetchingState, this.unsetFetchingState);

    return loadingPromise;
  }

  get childProps() {
    return {
      isCurrentSiteUserFetching: this.state.isFetching,
    };
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/current-site-user.js